import { useState, useRef, useEffect } from 'react'
import { LogOut } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext.jsx'

/**
 * Avatar chip in the top-right of TopNav. Clicking it opens a small popover
 * with the advisor's display name + a "Se déconnecter" action. Closes on
 * outside click and on Escape.
 */
export default function Avatar({ initials }) {
  const { usage, logout } = useAuth()
  const advisorName = usage?.advisor?.name
  const advisorEmail = usage?.advisor?.email
  const resolved = initials || (advisorName ? advisorName.trim()[0]?.toUpperCase() : null) || 'C'

  const [open, setOpen] = useState(false)
  const wrapRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const onDocClick = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false) }
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', onDocClick)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onDocClick)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <div ref={wrapRef} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        title={advisorName || 'Compte'}
        className="flex h-7 w-7 items-center justify-center rounded-full bg-ink text-[11px] font-semibold text-white transition-shadow hover:shadow-[0_0_0_3px_rgba(13,13,13,0.08)]"
      >
        {resolved}
      </button>
      {open && (
        <div className="absolute right-0 top-9 z-40 w-56 overflow-hidden rounded-xl border border-line bg-white shadow-[0_12px_28px_rgba(13,13,13,.10)]">
          {(advisorName || advisorEmail) && (
            <div className="border-b border-line/60 px-3.5 py-3">
              {advisorName && <div className="text-[13px] font-semibold leading-tight">{advisorName}</div>}
              {advisorEmail && <div className="mt-0.5 truncate text-[11.5px] text-muted">{advisorEmail}</div>}
            </div>
          )}
          <button
            onClick={() => { setOpen(false); logout?.() }}
            className="flex w-full items-center gap-2 px-3.5 py-2.5 text-left text-[13px] text-ink hover:bg-bg"
          >
            <LogOut size={14} strokeWidth={2} className="text-muted" />
            Se déconnecter
          </button>
        </div>
      )}
    </div>
  )
}
